import React from "react";

const BearIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg
    width="30"
    height="30"
    viewBox="0 0 30 30"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#fbIconClipPath)">
      <path
        d="M20.9311 14.8735C21.8982 18.7418 18.233 22.1556 14.9063 22.1556C11.5796 22.1556 7.35343 18.5484 8.89107 14.8735C10.6608 10.6571 11.5892 7.59149 14.9063 7.59149C18.2234 7.59149 19.8577 10.7248 20.9311 14.8735Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeMiterlimit="10"
      />
      <path
        d="M19.819 14.8735C20.7087 18.7418 17.44 22.1556 14.5001 22.1556C11.5602 22.1556 7.81762 18.5484 9.1812 14.8735C10.7382 10.6571 11.5602 7.59149 14.5001 7.59149C17.44 7.59149 18.8713 10.7248 19.819 14.8735Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeMiterlimit="10"
      />
      <path
        d="M17.1019 13.9355C16.9192 14.4208 16.6122 14.8495 16.2117 15.1788C15.8111 15.508 15.3311 15.7263 14.8196 15.8116C14.3161 15.706 13.8457 15.4803 13.4483 15.1536C13.0509 14.8269 12.7384 14.409 12.5373 13.9355C12.0731 12.9684 12.0248 12.0594 14.8196 12.0594C17.8175 12.0594 17.5467 12.9588 17.1019 13.9355Z"
        fill="currentColor"
      />
      <path
        d="M14.7324 28.6157C14.7324 28.6157 21.9757 27.0684 24.9833 22.9486C27.9909 18.8289 27.6911 15.3474 26.9175 12.9684C26.1438 10.5894 25.0607 8.13307 25.0607 8.13307C29.1321 5.42526 27.8749 3.13331 26.8788 1.82776C26.376 1.17983 24.1033 -1.07346 21.0764 3.60717H8.54311C5.49683 -1.05412 3.21454 1.17983 2.74067 1.82776C1.7736 3.13331 0.487391 5.42526 4.5491 8.13307C4.5491 8.13307 3.466 10.7055 2.70201 12.9684C1.93803 15.2314 1.73494 18.9063 4.63616 22.9486C7.24725 26.6525 14.7324 28.6157 14.7324 28.6157Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeMiterlimit="10"
      />
      <path
        d="M14.0943 28.6157C14.0943 28.6157 20.9799 27.0684 23.8424 22.9487C26.705 18.8289 26.4148 15.3475 25.6509 12.9685C24.8869 10.5895 23.8811 8.13309 23.8811 8.13309C27.7494 5.42529 26.7824 2.85288 25.6122 1.82779C25.0029 1.2959 23.2718 0.72532 21.0282 3.6072H8.20489C5.30367 -1.05409 3.14707 1.17985 2.6732 1.82779C1.70613 3.13333 0.526332 5.42529 4.39462 8.13309C4.39462 8.13309 3.35985 10.7055 2.63454 12.9685C1.90924 15.2314 1.66747 18.9063 4.44296 22.9487C6.97669 26.6525 14.0943 28.6157 14.0943 28.6157Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeMiterlimit="10"
      />
    </g>
    <defs>
      <clipPath id="fbIconClipPath">
        <rect
          width="27.5712"
          height="29.37"
          fill="white"
          transform="translate(1)"
        />
      </clipPath>
    </defs>
  </svg>
);

export default BearIcon;
